module.exports = __webpack_public_path__ + "img/symbol_arrow2yellow.fd311299.png";